import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Row, Col, Label, CustomInput, Modal, ButtonGroup } from 'reactstrap'
import _ from 'lodash'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { toast } from 'react-toastify'
import { Redirect } from 'react-router-dom'
import Reflux from 'reflux'
import DynamicTable from 'Components/dynamicTable'

const createEmptyFooterSection = () => ({
  FooterSectionID: 0,
  BrandID: 9,
  category: '',
  title: '',
  bodyText: '',
  buttonText: '',
  buttonLink: '',
  icon: ''
})

const iconOptions = ['Check', 'Faq', 'Heart', 'Lightbulb', 'PriceTag', 'QuestionMark', 'ShoppingCart', 'ThumbsUpDown', 'TrendingUp', 'Wallet']

export const FooterSectionForm = props => {
  const [footerSection, setFooterSection] = useState(createEmptyFooterSection())
  const [brands, setBrands] = useState([])
  const [footerSectionLoading, setFooterSectionLoading] = useState(false)
  const [brandsLoading, setBrandsLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const [isGlobal, setIsGlobal] = useState(true)
  const [links, setLinks] = useState([])
  const [showAddLinkModal, setShowAddLinkModal] = useState(false)
  const [addLinkPlacement, setAddLinkPlacement] = useState('FRONT')
  const [addLinkBrandId, setAddLinkBrandId] = useState(null)
  const isMsbBrand = Reflux.GlobalState.LoginStore.settings.BrandID === 9

  const getFooterSectionDetails = async FooterSectionID => {
    setFooterSectionLoading(true)

    const responseJson = await GET('footerSections/fetch', { FooterSectionID: FooterSectionID })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke hente footersektion: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setFooterSection(responseJson)
      }
    }

    setFooterSectionLoading(false)
  }

  const saveFooterSection = async () => {
    setFooterSectionLoading(true)

    if (!footerSection.timeEnd) {
      footerSection.timeEnd = null
    }
    const responseJson = await POST('footerSections/replace', footerSection)
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke gemme footersektion: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        toast.success('Footersektion er gemt', {
          autoClose: 7500
        })
        setRedirect(true)
      }
    }

    setFooterSectionLoading(false)
  }

  const getBrands = async () => {
    setBrandsLoading(true)
    const responseJson = await GET('menus/listBrands')
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke hente brands: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setBrands(responseJson)
      }
    }
    setBrandsLoading(false)
  }

  const getLinks = async FooterSectionID => {
    const responseJson = await GET(`footerSections/getBrandLinksForFooterSection`, { FooterSectionID: FooterSectionID })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke hente links: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setLinks(responseJson)
      }
    }
  }

  const addLink = async (FooterSectionID, BrandID, placement) => {
    const responseJson = await POST('footerSections/addBrandLink', { FooterSectionID: FooterSectionID, BrandID: BrandID, placement: placement })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke tilføje link: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setLinks([...links, { FooterSectionID: FooterSectionID, BrandID: BrandID, poolOrder: 0, placement: placement }])
        toast.success(`Tilføjede link til brand`, {
          autoClose: 7500
        })
      }
    }
  }

  const replaceLink = async (FooterSectionID, BrandID, poolOrder, placement) => {
    const responseJson = await POST('footerSections/replaceBrandLink', {
      FooterSectionID: FooterSectionID,
      BrandID: BrandID,
      placement: placement,
      poolOrder: poolOrder
    })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke opdatere link: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        const newLinks = links.map(l => {
          if (l.FooterSectionID === FooterSectionID) {
            return { ...l, poolOrder: poolOrder }
          } else {
            return l
          }
        })
        setLinks(newLinks)
        toast.success(`Opdaterede link`, {
          autoClose: 7500
        })
      }
    }
  }

  const removeLink = async (FooterSectionID, BrandID, placement) => {
    const responseJson = await POST('footerSections/removeBrandLink', { FooterSectionID: FooterSectionID, BrandID: BrandID, placement: placement })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Kunne ikke fjerne link: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        const newLinks = links.filter(l => l.BrandID !== BrandID)
        setLinks(newLinks)
        toast.success(`Fjernede link`, {
          autoClose: 7500
        })
      }
    }
  }

  const onAddLinkClick = () => {
    addLink(footerSection.FooterSectionID, addLinkBrandId, addLinkPlacement)
    setShowAddLinkModal(false)
  }

  useEffect(() => {
    const FooterSectionID = _.get(props, 'match.params.FooterSectionID')
    if (FooterSectionID) {
      getFooterSectionDetails(FooterSectionID)
    } else {
      const emptyFooterSection = createEmptyFooterSection()
      setFooterSection(emptyFooterSection)
    }

    if (FooterSectionID && isMsbBrand) {
      getBrands()
      getLinks(FooterSectionID)
    }
  }, [])

  if (redirect) {
    return <Redirect to={'/footer-sections'} />
  }

  if (footerSectionLoading) {
    return <FontAwesomeIcon icon='spinner' spin />
  }

  return (
    <>
      <CollapsibleCard startOpen header={<strong>{_.get(props, 'match.params.FooterSectionID') ? 'Detaljer' : 'Opret'}</strong>}>
        <Form>
          {isMsbBrand && (
            <Row className='mt-2'>
              <Col xs='2'>
                <Label for='icon'>Global (kan vælges af alle brands)</Label>
              </Col>
              <Col xs='10'>
                <CustomInput type='switch' checked={isGlobal} onChange={v => setIsGlobal(v.target.checked)} id='isGlobal' name='isGlobal' />
              </Col>
            </Row>
          )}
          {!isGlobal && isMsbBrand && (
            <Row className='mt-2'>
              <Col xs='2'>
                <Label for='BrandID'>Brand</Label>
              </Col>
              <Col xs='5'>
                {brandsLoading ? (
                  <FontAwesomeIcon icon='spinner' spin />
                ) : (
                  <Input
                    type='select'
                    value={Number(footerSection.BrandID)}
                    onChange={v => setFooterSection({ ...footerSection, BrandID: Number(v.target.value) })}
                  >
                    <option value=''>Vælg</option>
                    {brands.map((b, i) => {
                      return (
                        <option value={Number(b.BrandID)} key={i}>
                          {b.BrandID} - {b.brandName}
                        </option>
                      )
                    })}
                  </Input>
                )}
              </Col>
            </Row>
          )}
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='icon'>Ikon</Label>
            </Col>
            <Col xs='10'>
              <Input type='select' value={footerSection.icon} onChange={v => setFooterSection({ ...footerSection, icon: v.target.value })}>
                <option value=''>Vælg</option>
                {iconOptions.map((iconOption, i) => {
                  return (
                    <option value={iconOption} key={i}>
                      {iconOption}
                    </option>
                  )
                })}
              </Input>
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='title'>Titel</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='text'
                value={footerSection.title}
                onChange={v => setFooterSection({ ...footerSection, title: v.target.value })}
                invalid={!footerSection.title.length}
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='bodyText'>Brødtekst</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='textarea'
                value={footerSection.bodyText}
                onChange={v => setFooterSection({ ...footerSection, bodyText: v.target.value })}
              />
            </Col>
          </Row>
          <Row className='mt-5'>
            <Col xs='2'>
              <Label for='buttonText'>Knap tekst</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='text'
                value={footerSection.buttonText}
                onChange={v => setFooterSection({ ...footerSection, buttonText: v.target.value })}
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col xs='2'>
              <Label for='buttonLink'>Knap link</Label>
            </Col>
            <Col xs='10'>
              <Input
                type='text'
                value={footerSection.buttonLink}
                onChange={v => setFooterSection({ ...footerSection, buttonLink: v.target.value })}
              />
            </Col>
          </Row>

          <Button onClick={saveFooterSection} disabled={!footerSection.title || (isMsbBrand && !footerSection.BrandID)}>
            Gem
          </Button>
          <Button color='danger' onClick={() => setFooterSection(createEmptyFooterSection())} className='ml-2'>
            Nulstil
          </Button>
        </Form>
      </CollapsibleCard>
      {isMsbBrand && footerSection.BrandID === 9 && (
        <CollapsibleCard startOpen header={<strong>Brand Links</strong>}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div>
              <Button onClick={() => setShowAddLinkModal(true)}>+ Add Link</Button>
            </div>
            <DynamicTable
              responsive
              size='sm'
              options={{
                startSort: {
                  dir: 'DESC',
                  column: 'FooterSectionID'
                },
                fieldFunctions: {
                  poolOrder: e => {
                    return (
                      <Input
                        type='number'
                        defaultValue={e.poolOrder}
                        onBlur={v => {
                          replaceLink(e.FooterSectionID, e.BrandID, Number(v.target.value), e.placement)
                        }}
                        style={{ width: 100 }}
                      />
                    )
                  },
                  brand: e => {
                    const brand = brands.find(b => b.BrandID === e.BrandID)
                    return <>{brand?.brandName}</>
                  }
                },
                addField: e => {
                  return (
                    <td>
                      <ButtonGroup>
                        <Button
                          color='danger'
                          onClick={() => {
                            if (confirm('Vil du slette dette link?')) {
                              removeLink(e.FooterSectionID, e.BrandID, e.placement)
                            }
                          }}
                        >
                          <FontAwesomeIcon icon='trash' />
                        </Button>
                      </ButtonGroup>
                    </td>
                  )
                }
              }}
              headers={{
                BrandID: 'Brand ID',
                brand: 'Brand',
                placement: 'Placering',
                poolOrder: 'Rækkefølge'
              }}
              data={links}
            />
          </div>
        </CollapsibleCard>
      )}
      <Modal isOpen={showAddLinkModal} toggle={() => setShowAddLinkModal(false)}>
        <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 20 }}>
          <b>Add link</b>
          {brandsLoading ? (
            <FontAwesomeIcon icon='spinner' spin />
          ) : (
            <Input invalid={!addLinkBrandId} type='select' value={Number(addLinkBrandId)} onChange={v => setAddLinkBrandId(Number(v.target.value))}>
              <option value=''>Vælg</option>
              {brands.map((b, i) => {
                return (
                  <option value={Number(b.BrandID)} key={i}>
                    {b.BrandID} - {b.brandName}
                  </option>
                )
              })}
            </Input>
          )}
          <Input type='select' value={addLinkPlacement} onChange={v => setAddLinkPlacement(v.target.value)}>
            <option value='FRONT'>Forside</option>
            <option value='FAQ'>FAQ</option>
          </Input>
          <Button onClick={onAddLinkClick}>Add link</Button>
        </div>
      </Modal>
    </>
  )
}
